import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "detail-view px-[20rpx] pt-[20rpx] pb-[100rpx]" }
const _hoisted_2 = {
  key: 0,
  class: "detail-content"
}
const _hoisted_3 = {
  key: 0,
  class: "info-section"
}
const _hoisted_4 = { class: "info-label" }
const _hoisted_5 = { class: "info-value" }
const _hoisted_6 = {
  key: 0,
  class: "section-wrapper"
}
const _hoisted_7 = { class: "section-title" }
const _hoisted_8 = {
  key: 0,
  class: "section-count"
}
const _hoisted_9 = { class: "list-content" }
const _hoisted_10 = { class: "item-content" }
const _hoisted_11 = { class: "workshop-name" }
const _hoisted_12 = { class: "system-name" }
const _hoisted_13 = { class: "item-name" }
const _hoisted_14 = { class: "item-name" }
const _hoisted_15 = {
  key: 0,
  class: "item-value"
}
const _hoisted_16 = {
  key: 1,
  class: "remark-section"
}
const _hoisted_17 = { class: "remark-content" }
const _hoisted_18 = {
  key: 2,
  class: "attachment-section"
}
const _hoisted_19 = { class: "section-title" }
const _hoisted_20 = { class: "list-system" }
const _hoisted_21 = { class: "baseCharger" }
const _hoisted_22 = { class: "initOpinion" }
const _hoisted_23 = { class: "sign-photo-section" }
const _hoisted_24 = { class: "totalCharger" }
const _hoisted_25 = { class: "reviewOpinion" }
const _hoisted_26 = { class: "review-sign-photo-section" }
const _hoisted_27 = {
  key: 1,
  class: "bottom-actions"
}

import { ref, computed } from 'vue';
import { navigateTo, navigateBack } from '@tarojs/taro';
import attachment from '@/pages/equipmentLifecycle/components/attachment.vue';

// 定义组件 Props
interface BasicInfoItem {
  label: string;
  value: string | number;
}

interface ListSection {
  title: string;
  data: any[];
  unit: string;
  type: 'system' | 'status' | 'default';
  nameField: string;
  valueField?: string;
  statusField?: string;
  workshopField?: string;
  completedText?: string;
  uncompletedText?: string;
}

interface Action {
  text: string;
  type?: 'primary' | 'default';
  className?: string;
  handler: 'edit' | 'back' | 'custom';
  url?: string;
  customHandler?: () => void;
}

interface DetailViewProps {
  detailData?: any;
  basicInfo?: BasicInfoItem[];
  listSections?: ListSection[];
  remark?: string;
  attachments?: any[];
  actions?: Action[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    detailData: {},
    basicInfo: { default: () => [] },
    listSections: { default: () => [] },
    remark: {},
    attachments: {},
    actions: { default: () => [] }
  },
  setup(__props: any) {

const props = __props;

// 创建 attachment 组件的引用
const attachmentRef = ref<InstanceType<typeof attachment> | null>(null);

// 获取嵌套对象的值
const getNestedValue = (obj: any, path: string) => {
  return path.split('.').reduce((current, key) => {
    return current && current[key] !== undefined ? current[key] : '';
  }, obj);
};

// 处理操作按钮点击
const handleAction = (action: Action) => {
  switch (action.handler) {
    case 'edit':
      // 编辑操作 - 需要从外部传入 reportId
      if (action.url) {
        navigateTo({ url: action.url });
      }
      break;
    case 'back':
      // 返回操作
      if (action.url) {
        console.log(123);
        navigateTo({ url: action.url });
      } else {
        navigateBack();
      }

      break;
    case 'custom':
      // 自定义操作
      if (action.customHandler) {
        action.customHandler();
      }
      break;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_nut_button = _resolveComponent("nut-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.detailData)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.basicInfo && _ctx.basicInfo.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.basicInfo, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "info-item"
                  }, [
                    _createElementVNode("div", _hoisted_4, [
                      _renderSlot(_ctx.$slots, "basic-info-label", {
                        item: item,
                        index: index
                      }, () => [
                        _createTextVNode(_toDisplayString(item.label), 1)
                      ], true)
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                      _renderSlot(_ctx.$slots, "basic-info-value", {
                        item: item,
                        index: index
                      }, () => [
                        _createTextVNode(_toDisplayString(item.value || '-'), 1)
                      ], true)
                    ])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listSections, (section, sectionIndex) => {
            return (_openBlock(), _createElementBlock("div", {
              key: sectionIndex,
              class: "list-section"
            }, [
              (section.data && section.data.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createTextVNode(_toDisplayString(section.title) + " ", 1),
                      (section.unit)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(section.unit ? `(${section.data.length}${section.unit})` : ''), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.data, (item, itemIndex) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: itemIndex,
                          class: "list-item"
                        }, [
                          _createElementVNode("div", _hoisted_10, [
                            _renderSlot(_ctx.$slots, "list-item", {
                              item: item,
                              index: itemIndex,
                              section: section,
                              sectionIndex: sectionIndex
                            }, () => [
                              (section.type === 'system')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createElementVNode("div", _hoisted_11, _toDisplayString(getNestedValue(item, section.workshopField || '')), 1),
                                    _createElementVNode("div", _hoisted_12, _toDisplayString(getNestedValue(item, section.nameField)), 1)
                                  ], 64))
                                : (section.type === 'status')
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createElementVNode("div", _hoisted_13, _toDisplayString(getNestedValue(item, section.nameField)), 1),
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["item-status", {
                        completed: getNestedValue(
                          item,
                          section.statusField || ''
                        ),
                      }])
                                      }, _toDisplayString(getNestedValue(item, section.statusField || '')
                          ? section.completedText
                          : section.uncompletedText), 3)
                                    ], 64))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                      _createElementVNode("div", _hoisted_14, _toDisplayString(getNestedValue(item, section.nameField)), 1),
                                      (section.valueField)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(getNestedValue(item, section.valueField)), 1))
                                        : _createCommentVNode("", true)
                                    ], 64))
                            ], true)
                          ])
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128)),
          (_ctx.remark)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "section-title" }, "备注信息", -1)),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.remark), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.attachments && _ctx.attachments.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, " 附件信息 (" + _toDisplayString(_ctx.attachments.length) + "个文件) ", 1),
                _createVNode(attachment, {
                  ref_key: "attachmentRef",
                  ref: attachmentRef,
                  files: props.attachments,
                  "onUpdate:files": _cache[0] || (_cache[0] = ($event: any) => ((props.attachments) = $event)),
                  mode: "view"
                }, null, 8, ["files"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_20, [
            _renderSlot(_ctx.$slots, "system-list", {}, undefined, true)
          ]),
          _createElementVNode("div", _hoisted_21, [
            _renderSlot(_ctx.$slots, "base-charger", {}, undefined, true)
          ]),
          _createElementVNode("div", _hoisted_22, [
            _renderSlot(_ctx.$slots, "init-opinion", {}, undefined, true)
          ]),
          _createElementVNode("div", _hoisted_23, [
            _renderSlot(_ctx.$slots, "sign-photo", {}, undefined, true)
          ]),
          _createElementVNode("div", _hoisted_24, [
            _renderSlot(_ctx.$slots, "total-charger", {}, undefined, true)
          ]),
          _createElementVNode("div", _hoisted_25, [
            _renderSlot(_ctx.$slots, "review-opinion", {}, undefined, true)
          ]),
          _createElementVNode("div", _hoisted_26, [
            _renderSlot(_ctx.$slots, "review-sign-photo", {}, undefined, true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.detailData && _ctx.actions && _ctx.actions.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actions, (action, index) => {
            return (_openBlock(), _createBlock(_component_nut_button, {
              key: index,
              type: action.type || 'default',
              class: _normalizeClass(['action-btn', action.className]),
              onClick: ($event: any) => (handleAction(action))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(action.text), 1)
              ]),
              _: 2
            }, 1032, ["type", "class", "onClick"]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})